import React from 'react'

import { IconButton, Menu } from '@material-ui/core'

import MoreVertIcon from '@material-ui/icons/MoreVert'

const TableDropdown = ({ children }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton size='small' className='p-0' aria-label='More' aria-controls='long-menu' aria-haspopup='true' onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {children({ handleClose })}
      </Menu>
    </div>
  )
}

export default TableDropdown
